{
  "brandTitle": "VBB PLAY — Canlı Destek",
  "brandShort": "VBB PLAY Destek",
  "liveLabel": "VBB PLAY Canlı Destek",
  "online": "Çevrimiçi",
  "offline": "Çevrimdışı",
  "close": "Kapat",
  "moreOptions": "Diğer seçenekler",
  "closeChat": "Sohbeti kapat",
  "closeMenu": "Menüyü kapat",
  "operator": "VBB PLAY Operatör",
  "removeFile": "Dosyayı kaldır",
  "attachFile": "Dosya ekle",
  "loadFailed": "Yüklenemedi.",
  "fileTooLarge": "Dosya 50 MB'den büyük.",
  "sendFailed": "Mesaj gönderilmedi ({{status}})",
  "networkError": "Ağ hatası. Lütfen tekrar deneyin.",
  "nameRequired": "Adınızı girin.",
  "emailInvalid": "Geçerli bir e-posta adresi girin.",
  "topicRequired": "Bir konu seçin.",
  "messageRequired": "Sorununuzu kısaca açıklayın.",
  "consentRequired": "Gizlilik onayı zorunludur.",
  "requestFailed": "Talep başarısız oldu.",
  "messagePlaceholder": "Kısa bir açıklama yazın…",
  "sending": "Gönderiliyor…",
  "startLive": "Canlı Desteği başlat",
  "ratingFailed": "Puan gönderilemedi.",
  "ratingPlaceholder": "Kısa yorum (isteğe bağlı)",
  "contactSaveFailed": "İletişim bilgileri kaydedilemedi.",
  "save": "Kaydet",
  "loginRequired": "Canlı Destek için giriş yapın.",
  "intakeHint": "Daha hızlı yardımcı olabilmemiz için bilgilerinizi girin.",
  "back": "Geri",
  "yourName": "Adınız",
  "yourEmail": "E-postanız (Gmail veya diğer)",
  "emailPlaceholder": "email@example.com",
  "topicLabel": "Konu",
  "topicSelect": "Seçin…",
  "messageLabel": "Sorununuz veya mesajınız",
  "consentLong": "Kişisel verilerin işlenmesine izin veriyorum ve Gizlilik Politikasını okudum.",
  "soundOff": "🔊 Sesi kapat",
  "soundOn": "🔇 Sesi aç",
  "rateOperator": "⭐ Operatörü puanla",
  "editContact": "✎ Kişisel bilgilerimi düzenle",
  "searchingOperator": "🔎 Operatör aranıyor...",
  "waitingOperator": "⏳ Talebiniz alındı. Operatör bekleniyor.",
  "operatorJoined": "{{name}} operatörü sohbete katıldı",
  "sendFailedShort": "Gönderilmedi",
  "retry": "Tekrar dene",
  "cameraShot": "📷 Fotoğraf çek",
  "pickPhoto": "🖼️ Fotoğraf seç",
  "pickVideo": "🎬 Video seç",
  "pickFile": "📁 Dosya veya belge seç",
  "textPlaceholder": "Mesaj...",
  "messageAria": "Mesaj",
  "sendAria": "Gönder",
  "emojiAria": "Emoji",
  "rateTitle": "Operatörü puanla",
  "submitRate": "Gönder",
  "editContactTitle": "Kişisel bilgilerimi düzenle",
  "cameraPermissionTitle": "Kamera izni",
  "cameraPermissionBody": "Fotoğraf çekmek için kamera erişimi gerekir. Tarayıcı istemi cihaz dilinde kalabilir.",
  "allowCamera": "İzin ver",
  "notNow": "Şimdi değil",
  "namePlaceholder": "Ad",
  "topic_deposit": "Yatırım sorunu",
  "topic_withdraw": "Çekim sorunu",
  "topic_balance": "Bakiye sorunu",
  "topic_game": "Oyun sorunu",
  "topic_bonus": "Bonus sorunu",
  "topic_account": "Hesap / giriş sorunu",
  "topic_tech": "Teknik sorun",
  "topic_other": "Diğer soru",
  "fileOpenFailed": "Dosya açılamadı: {{name}}",
  "retryShort": "Tekrar dene",
  "fileLoading": "Dosya yükleniyor: {{name}}",
  "emoji_smileys": "İfadeler",
  "emoji_people": "Jestler",
  "emoji_nature": "Doğa",
  "emoji_food": "Yiyecek",
  "emoji_activity": "Spor",
  "emoji_travel": "Seyahat",
  "emoji_objects": "Nesneler",
  "emoji_symbols": "Semboller",
  "emoji_flags": "Bayraklar"
}
